import { Message, MessageBox } from 'element-ui';

export function successMsg(msg, duration) {
    Message({
        message: msg,
        type: 'success',
        duration: Number.isFinite(duration) ? duration : 3000,
        customClass: 'zZindex'
    });
}

export function failureMsg(msg, duration) {
    Message({
        message: msg,
        type: 'error',
        duration: Number.isFinite(duration) ? duration : 5000,
        customClass: 'zZindex'
    });
}

export function showMsgBox(title, msg) {
    MessageBox({
        title,
        message: msg,
        customClass: 'zZindex',
        confirmButtonText: '确定',
        center: true
      });
}